import services from '@/services/ascentiaServiceIndex'
import {
  FULL_FLIGHT_TIER_2,
  COLLINS_PHM_TIER_3,
  COLLINS_PHM_TIER_4,
} from '@/utilities/appConsts'
import { ANSER_TOOL_CONSTS as ATC } from '../consts'

const state = {
  signaturesLoading: false,
  signatures: [],
}

const getters = {
  mappedUserAirlinesWithMasterModelsTierTypeIds(
    state,
    getters,
    rootState,
    rootGetters,
  ) {
    const airlines = rootState.user.airlines
    const masterModelsData = rootGetters['lookups/mappedLuMasterModels']
    const mappedAircraft = rootGetters['lookups/mappedAircraft']

    if (airlines.length > 0 && masterModelsData.length > 0) {
      const items = airlines
        .map(selectedAirline => {
          const foundAircraft = mappedAircraft.filter(
            aircraft => aircraft.airlineId === selectedAirline.id,
          )

          return {
            airlineId: selectedAirline.id,
            displayName: selectedAirline.name,
            value: selectedAirline.id,
            icaoCode: selectedAirline.icaoCode,
            airlineTierTypeIds: [
              ...new Set(foundAircraft.map(fa => fa.airlineTierTypeId)),
            ], // Can have multiple tiers for any airline
          }
        })
        .map(item => {
          const mms = masterModelsData
            .sort((a, b) =>
              a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
            )
            .filter(mm => mm.airlineId === item.airlineId)

          return {
            ...item,
            platforms: mms,
          }
        })

      return items.sort((a, b) =>
        a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1,
      )
    }

    return []
  },

  mappedGFUserAirlinesWithMasterModels(state, getters, rootState, rootGetters) {
    const selections = rootGetters['globalFilter/selections']
    const mappedUserAirlinesWithMasterModels =
      getters.mappedUserAirlinesWithMasterModelsTierTypeIds

    if (mappedUserAirlinesWithMasterModels.length) {
      return mappedUserAirlinesWithMasterModels.filter(item => {
        return (
          [FULL_FLIGHT_TIER_2, COLLINS_PHM_TIER_3, COLLINS_PHM_TIER_4].some(
            tierId => item.airlineTierTypeIds.includes(tierId),
          ) &&
          (selections.length === 0 ||
            selections.filter(
              selection => selection.airlineId === item.airlineId,
            ).length > 0)
        )
      })
    }

    return []
  },
}

const mutations = {
  [ATC.UPDATE_SIGNATURES]: (state, data) => (state.signatures = data),
  [ATC.SIGNATURES_LOADING]: (state, data) => (state.signaturesLoading = data),
}

const actions = {
  async [ATC.GET_SIGNATURES]({ commit }, airlines) {
    try {
      if (airlines.length) {
        commit(ATC.SIGNATURES_LOADING, true)
        const response = await services.anserTool.getData(
          'signatures',
          airlines,
          true,
        )
        const data = response.data
        if (data.length) {
          const updatedSignatures = airlines.map(airline => {
            const foundSignatureData = data.find(
              signature => signature.name === airline.icaoCode,
            )

            if (foundSignatureData) {
              return {
                ...airline,
                platforms: airline.platforms.map(platform => {
                  const foundPlatform = foundSignatureData.platform.find(
                    sp => sp.name === platform.text,
                  )
                  if (foundPlatform) {
                    return { ...platform, ...foundPlatform }
                  }
                  return {
                    ...platform,
                    ...{ signatures: 0, lastModifiedDate: '' },
                  }
                }),
              }
            } else {
              return airline
            }
          })

          commit(ATC.UPDATE_SIGNATURES, updatedSignatures)
          commit(ATC.SIGNATURES_LOADING, false)
        } else {
          commit(ATC.UPDATE_SIGNATURES, [])
          commit(ATC.SIGNATURES_LOADING, false)
        }
      }
    } catch (error) {
      console.log(`${[ATC.GET_SIGNATURES]}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
